/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ language: NonNullable<unknown> }} No_Transcript_For_LanguageInputs */

const en_no_transcript_for_language = /** @type {(inputs: No_Transcript_For_LanguageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No transcript found for the selected language: ${i?.language}.`)
};

const fr_no_transcript_for_language = /** @type {(inputs: No_Transcript_For_LanguageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aucune transcription trouvée pour la langue sélectionnée : ${i?.language}.`)
};

const de_no_transcript_for_language = /** @type {(inputs: No_Transcript_For_LanguageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Für die ausgewählte Sprache wurde kein Transkript gefunden: ${i?.language}.`)
};

const it_no_transcript_for_language = /** @type {(inputs: No_Transcript_For_LanguageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nessuna trascrizione trovata per la lingua selezionata: ${i?.language}.`)
};

const ru_no_transcript_for_language = /** @type {(inputs: No_Transcript_For_LanguageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Транскрипт для выбранного языка не найден: ${i?.language}.`)
};

const es_no_transcript_for_language = /** @type {(inputs: No_Transcript_For_LanguageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se encontró ninguna transcripción para el idioma seleccionado: ${i?.language}.`)
};

const zh_cn2_no_transcript_for_language = /** @type {(inputs: No_Transcript_For_LanguageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`未找到所选语言的转录文本：${i?.language}。`)
};

const ja_no_transcript_for_language = /** @type {(inputs: No_Transcript_For_LanguageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`選択された言語のトランスクリプトが見つかりません: ${i?.language}。`)
};

const hi_no_transcript_for_language = /** @type {(inputs: No_Transcript_For_LanguageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`चुनी गई भाषा के लिए कोई प्रतिलेख नहीं मिला: ${i?.language}.`)
};

const pt_pt2_no_transcript_for_language = /** @type {(inputs: No_Transcript_For_LanguageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Não foi encontrada nenhuma transcrição para o idioma selecionado: ${i?.language}.`)
};

/**
* | output |
* | --- |
* | "No transcript found for the selected language: {language}." |
*
* @param {No_Transcript_For_LanguageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const no_transcript_for_language = /** @type {((inputs: No_Transcript_For_LanguageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Transcript_For_LanguageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_no_transcript_for_language(inputs)
	if (locale === "de") return de_no_transcript_for_language(inputs)
	if (locale === "it") return it_no_transcript_for_language(inputs)
	if (locale === "ru") return ru_no_transcript_for_language(inputs)
	if (locale === "es") return es_no_transcript_for_language(inputs)
	if (locale === "zh-CN") return zh_cn2_no_transcript_for_language(inputs)
	if (locale === "ja") return ja_no_transcript_for_language(inputs)
	if (locale === "hi") return hi_no_transcript_for_language(inputs)
	if (locale === "pt-PT") return pt_pt2_no_transcript_for_language(inputs)
	return en_no_transcript_for_language(inputs)
});